import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

interface DraggableAnalyseRowProps {
  id: string;
  children: React.ReactNode;
}

export default function DraggableAnalyseRow({ id, children }: DraggableAnalyseRowProps) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({ id });

  const style = transform ? {
    transform: CSS.Translate.toString(transform),
    zIndex: isDragging ? 50 : 'auto',
    opacity: isDragging ? 0.4 : 1,
  } : undefined;

  return (
    <div ref={setNodeRef} style={style} className="flex items-center group/drag">
      <button
        {...listeners}
        {...attributes}
        className="cursor-grab active:cursor-grabbing p-1.5 text-gray-300 hover:text-teal-500 transition-colors flex-shrink-0 touch-none"
        title="Maintenir pour déplacer"
      >
        <i className="ri-draggable text-lg"></i>
      </button>
      <div className="flex-1 min-w-0">
        {children}
      </div>
    </div>
  );
}